/**
 * Converts a value to a base64 encoded string.
 *
 * @param value - The value to convert.
 * @returns The base64 encoded string.
 */
export function toBase64(value: any) {
  if (value === undefined || value === null) {
    return "";
  }

  const jsonString = JSON.stringify(value);
  const bytes = new TextEncoder().encode(jsonString);
  const binString = String.fromCodePoint(...bytes);

  return btoa(binString);
}

/**
 * Converts a base64 encoded string to a value.
 *
 * @param value - The base64 encoded string.
 * @param defaultValue - The default value to return if the conversion fails.
 * @returns The value.
 */
export function fromBase64<T>(value: string, defaultValue: T): T {
  try {
    const binString = atob(value);

    const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0) ?? 0);
    const jsonString = new TextDecoder().decode(bytes);

    return JSON.parse(jsonString) as T;
  } catch {
    return defaultValue;
  }
}
